import { Inject, Injectable, InjectionToken } from '@angular/core';
import { CacheService } from '@se/se.ui.html5';
import { Observable, from } from 'rxjs';


export const ESTENSA_MODULE_COMMON_SETTINGS_SERVICE = new InjectionToken('estensa.module.common-settings.service');

@Injectable({
    providedIn: 'root',
})
export class CommonSettingsService {

    constructor(@Inject(ESTENSA_MODULE_COMMON_SETTINGS_SERVICE) private settingsService,
                private cacheService: CacheService) { }

    getSettings(): Observable<any> {
        return this.cacheService.get(
            'CommonSettings',
            from(this.settingsService.getAsJSON()),
        );
    }
}
